// Generated from src/assets/BorderedClose.svg
import React, { PureComponent } from "react";

interface ISVGContrastIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGContrastIcon extends PureComponent<
  ISVGContrastIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        width="35px"
        height="35px"
        viewBox="0 0 35 35"
        enableBackground="new 0 0 35 35"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.494,3.38c0,9.354,0,18.71,0,28.063
	c-7.357,0.086-11.382-4.302-13.338-9.7c-0.701-1.935-1.11-5.782-0.347-8.141C5.616,8.017,10.051,3.301,17.494,3.38z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.556,0.089C7.939,0.089,0.144,7.884,0.144,17.5
	c0,9.616,7.795,17.412,17.412,17.412c9.615,0,17.411-7.795,17.411-17.412C34.966,7.884,27.171,0.089,17.556,0.089z M17.556,32.859
	c-8.483,0-15.36-6.876-15.36-15.36c0-8.482,6.876-15.359,15.36-15.359c8.482,0,15.359,6.876,15.359,15.359
	C32.915,25.983,26.038,32.859,17.556,32.859z"
        />
      </svg>
    );
  }
}
